import { render, staticRenderFns } from "./FeatureGuide.vue?vue&type=template&id=9671b2ce&scoped=true"
import script from "./FeatureGuide.vue?vue&type=script&lang=js"
export * from "./FeatureGuide.vue?vue&type=script&lang=js"
import style0 from "./FeatureGuide.vue?vue&type=style&index=0&id=9671b2ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.18.1_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9671b2ce",
  null
  
)

export default component.exports